import { render } from "./BusInfoCard.vue?vue&type=template&id=1c576a69&ts=true"
import script from "./BusInfoCard.vue?vue&type=script&lang=ts"
export * from "./BusInfoCard.vue?vue&type=script&lang=ts"

import "./BusInfoCard.vue?vue&type=style&index=0&id=1c576a69&lang=scss"

import exportComponent from "/Users/phoebe/projects/find-bus-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__